import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

export interface VehiculoPesvPayload {
  placa: string;
  ciudad: number;
  sede: number;
  fecha_ingreso: string;
  numero_vin: number;
  fecha_fabricacion: string;
  motor: number;
  licencia: number;
  tarjeta_operacion: number;
  kilometraje: number;
  promedio_kilometraje: number;
  clase: string;
  tipo: number;
  marca: string;
  modelo: number;
  color: string;
  linea: string;
  matricula: number;
  propietario: string;
  cedula: number;
  contacto: number;
  empresa: string;
  contacto_empresa: number;
  cod_infracion: number;
  ultima_revision: string;
  fecha_siniestros: string;
  lugar_siniestros: string;
  area_rural: number;
  vencimiento_soat: string;
  estado_soat: string;
  vencimiento_rc: string;
  estrado_rc: string;
  vencimentio_tecnomecanica: string;
  estado_tecnomecanica: string;
  vencimiento_mantenimiento: string;
  estado_mantenimiento: string;
  estado?: number;
}

@Injectable({
  providedIn: "root",
})
export class VehiculosPesvService {
  private apiUrl = `${environment.apiUrl}/api/vehiculos_pesv`;

  constructor(private http: HttpClient) {}

  create(payload: VehiculoPesvPayload): Observable<any> {
    return this.http.post<any>(this.apiUrl, payload, { withCredentials: true });
  }

  update(id: number, payload: VehiculoPesvPayload): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, payload, { withCredentials: true });
  }

  getAll(): Observable<any> {
    return this.http.get<any>(this.apiUrl, { withCredentials: true });
  }
}
